const getIconContent = ({ path, width, height }) => {
    const markerIcon = document.createElement('img');
    markerIcon.src = path;
    markerIcon.style.width = `${width}px`;
    markerIcon.style.height = `${height}px`;
    markerIcon.style.setProperty('max-width', 'none', 'important');
    return markerIcon;
};
const getIconAnchor = ({ naver, width, height }) => {
    const anchor = new naver.maps.Point(width / 2, height);
    return anchor;
};
/**
 * markerType에 따라 마커의 이미지가 변경됩니다.
 * 준비된 마커타입 이미지는 worker, store, drop이 있습니다.(7.11. 기준)
 */
export default ({ naver, markerType }) => {
    const iconSize = {
        store: {
            width: 32,
            height: 40,
        },
        // HUB 등 추후 필요시 확장
    };
    const path = `/svg/map-control/${markerType}-normal-active.svg`;
    const { width, height, } = iconSize[markerType];
    return {
        size: iconSize[markerType],
        anchor: getIconAnchor({
            naver,
            width,
            height,
        }),
        content: getIconContent({
            path,
            width,
            height,
        }),
    };
};
